export class PaginationObserver {
    private intersectionObserver: IntersectionObserver;
    private static instance: PaginationObserver;

    constructor(callback: IntersectionObserverCallback) {
        this.intersectionObserver = new IntersectionObserver(callback);
    }

    public observe(el: Element): void {
        this.intersectionObserver.observe(el);
    }

    public unobserve(el: Element): void {
        this.intersectionObserver.unobserve(el);
    }

    public disconnect(): void {
        this.intersectionObserver.disconnect();
    }

    public static init(externalCallback: IntersectionObserverCallback): void {
        PaginationObserver.instance = new PaginationObserver(externalCallback);
    }

    public static getInstance(): PaginationObserver {
        if (!PaginationObserver.instance) {
            PaginationObserver.instance = new PaginationObserver(() => {
                console.log('observer');
            });
        }

        return PaginationObserver.instance;
    }
}
